var map = {
	"./authentication-en.json": [
		12638,
		"libs_authentication_src_assets_i18n_lib_authentication_authentication-en_json"
	],
	"./authentication-fr.json": [
		41337,
		"libs_authentication_src_assets_i18n_lib_authentication_authentication-fr_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 32960;
module.exports = webpackAsyncContext;